module.exports = __webpack_public_path__ + "img/stereoscopic_cam1.ca87d76c.png";